var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38 92a12 12 0 1 0-12 12 12.013 12.013 0 0 0 12-12Zm-20 0a8 8 0 1 1 8 8 8.01 8.01 0 0 1-8-8Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 94h8.139a14.473 14.473 0 0 1 0-4H4V76h66v14H41.861a14.473 14.473 0 0 1 0 4H87.14a14.473 14.473 0 0 1 0-4H74V48a2.002 2.002 0 0 1 2-2h16.903a1.998 1.998 0 0 1 1.763 1.054l8.086 15.059a1.999 1.999 0 0 0 2.075 1.03c.069-.013 7.05-1.057 12.527 3.331 3.948 3.163 6.184 8.408 6.646 15.59V90h-5.139a14.473 14.473 0 0 1 0 4H126a2 2 0 0 0 2-2V82c0-.042-.001-.084-.004-.125-.527-8.385-3.267-14.617-8.142-18.523a21.303 21.303 0 0 0-14.204-4.297l-7.46-13.893A5.99 5.99 0 0 0 92.902 42H76a6.007 6.007 0 0 0-6 6v24H2a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 92a12 12 0 1 0-12 12 12.013 12.013 0 0 0 12-12Zm-20 0a8 8 0 1 1 8 8 8.01 8.01 0 0 1-8-8ZM13 28h10.257a2 2 0 1 0 0-4H13a2 2 0 0 0 0 4ZM42.743 24a2 2 0 0 0 0 4H53a2 2 0 0 0 0-4ZM11 68h44a11.012 11.012 0 0 0 11-11V43a11.012 11.012 0 0 0-11-11H11A11.012 11.012 0 0 0 0 43v14a11.012 11.012 0 0 0 11 11ZM4 43a7.008 7.008 0 0 1 7-7h44a7.008 7.008 0 0 1 7 7v14a7.008 7.008 0 0 1-7 7H11a7.008 7.008 0 0 1-7-7Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasTransportation);
export default __webpack_public_path__ + "static/media/GasTransportation.75b25fae579dee724d3ce1b43091db95.svg";
export { ForwardRef as ReactComponent };